import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";

import "../destinations_module/destinations-group.scss";
import "../destinations_module/destinations-card.scss";
import "./vacation_homes.scss";

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));